<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Quote</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/quotes" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createQuote" v-if="quote">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="quote.author"
                                          label="Author"
                                          placeholder="Enter Author"
                                          v-validate="rules.author"
                                          data-vv-name="Author"
                                          cus-name="Author"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="quote.quote"
                                      label="Quote"
                                      placeholder="Enter Quote"
                                      data-vv-name="Quote"
                                      v-validate="rules.quote"
                                      cus-name="Quote"
                                      :has-errors="errors"
                                      :is-fields="fields"
                                      >
                            </fg-input>
                          </div>
                          <div class="col-12" v-if="corps.length">
                            <multiselect
                              v-model="quote.csvCorporationId"
                              placeholder="Select Corporation"
                              :multiple="true"
                              :taggable="true"
                              :options="corps.map(type => type.corporationId)"
                              :custom-label="opt => corps.find(x => x.corporationId == opt).name"
                              required>
                              >
                            </multiselect>
                          </div>
                            <div class="col-3" v-if="status.length">
                              <fg-select
                                v-model="quote.active"
                                label="isActive"
                                v-validate="rules.active"
                                data-vv-name="active"
                                cus-name="active"
                                :has-errors="errors"
                                :is-fields="fields"
                                :list="status"
                                selectedKey="id"
                              >
                              </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Quote
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateQuote',
        created (){
    },
    data () {
        return {
            quote: {
                author: '',
                quote: '',
                active: '1',
              csvCorporationId: null,
            },
          corps: [],
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              author: {required : true},
              quote: {required : true},
              active: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        createQuote () {
          console.log("this.quote : ", this.quote);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_QUOTE', this.quote)
                .then((res) => {
                  console.log("ADD_QUOTE res : ", res);
                  if(res) this.showPopup('Success!', 'Quote is successfully created', 'success', ()=>this.$router.push('/admin/quotes'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_QUOTE API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {
    this.fetchCorporations();
    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Quotes/CreateQuote.vue